import React from 'react';
// import optgroup from '@mui/material/optgroup';

import { useRecoilStateLoadable } from 'recoil';
import { metrics } from '../../../recoil/selectors/metrics';
import { FormControl, InputLabel, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles((theme) => ({
  metricDropdown: {
    marginLeft: '0.8vw',
    marginTop: '10px',
  },
}));

type Props = {
  customStyles?: Record<string, string>;
  formik: any;
  handleOnChange: (e: any) => any;
  defaultMetric?: string;
};

export function MetricDropdownFormik(props: Props) {
  const classes = useStyles();
  const [metricLoadable, setMetric] = useRecoilStateLoadable<any>(metrics);

  function metricHandler(e) {
    const [title, key] = e.target.value.split(',');
    // const [title, key] = "Missed Calls,allmissed",
    // console.log(split)
    setMetric({
      title,
      key,
    });
    props.handleOnChange(e.target.value);
  }
  const defaults = [
    {
      title: 'All Connections',
      key: 'allconnections',
      groups: ['Connections'],
    },
    {
      title: 'Answered Calls',
      key: 'allanswered',
      groups: ['Total'],
    },
    {
      title: 'Missed Calls',
      key: 'allmissed',
      groups: ['Total'],
    },
    {
      title: 'Outgoing Calls',
      key: 'alloutgoing',
      groups: ['Outgoing'],
    },
    {
      title: 'Answered',
      key: 'outgoinganswered',
      groups: ['Outgoing'],
    },
    {
      title: 'Missed',
      key: 'outgoingmissed',
      groups: ['Outgoing'],
    },
    {
      title: 'Connections',
      key: 'outgoingconnection',
      groups: ['Outgoing'],
    },
    {
      title: 'Incoming Calls',
      key: 'allincoming',
      groups: ['Incoming'],
    },
    {
      title: 'Answered',
      key: 'incominganswered',
      groups: ['Incoming'],
    },
    {
      title: 'Missed',
      key: 'incomingmissed',
      groups: ['Incoming'],
    },
    {
      title: 'Connections',
      key: 'incomingconnection',
      groups: ['Incoming'],
    },
    {
      title: 'Total Duration',
      key: 'tduration',
      groups: ['Duration'],
    },
    {
      title: 'Avg. Duration',
      key: 'allavgduration2',
      groups: ['Duration'],
    },
  ];
  const groupTypes = [
    'Connections',
    'Total',
    'Outgoing',
    'Incoming',
    'Duration',
  ];
  return (
    <FormControl
      className={classes.metricDropdown}
      size="small"
      variant="outlined"
    >
      <InputLabel>Metric</InputLabel>
      <Select
        defaultValue={
          props.defaultMetric
            ? props.defaultMetric
            : metricLoadable.state === 'hasValue'
            ? `${metricLoadable?.contents?.current?.title},${metricLoadable?.contents?.current?.key}`
            : 'All Connections,allconnections'
        }
        native
        onChange={metricHandler}
        label="Metric"
        name="metric-dropdown"
        // style={{ width: '400px' }}
        style={props.customStyles && { ...props.customStyles }}
      >
        {groupTypes.map((group) => (
          <optgroup key={group} label={group}>
            {defaults
              .filter((metric) => metric.groups.includes(group))
              .map((metric) => (
                <option
                  key={metric.key}
                  value={`${metric?.title},${metric?.key}`}
                >
                  {metric?.title}
                </option>
              ))}
          </optgroup>
        ))}
      </Select>
    </FormControl>
  );
}
